// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__15bPy","column":"style_column__b8IrL","row":"style_row__xrLRk"};